import React, { memo } from 'react';
import { Stack, Chip } from '@mui/material';
import { NodeBox } from '../../components/NodeBox';
import { ResourceName } from '../../components/ResourceName';
import styles from './Request.module.scss';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import { Button } from 'new/elements/Button';
import { RequestActions } from './RequestActions';
import { useApiRequestModal } from 'new/components/flows/types/api_server/context/ApiRequestModal/ApiRequestModalContext';
import useDataSet from 'new/state/data_set/repository/useDataSet';
import { getHttpMethodColor } from 'js/lib/ApiServerUtils';

interface RequestProps {
  data: any;
  isPreview?: boolean;
}

export const Request = memo((props: RequestProps) => {
  const { data, isPreview } = props;
  const { openTestModal, openConfigModal } = useApiRequestModal();
  const { getDataSetById } = useDataSet();
  const dataset = getDataSetById(data?.id);
  const requestName = dataset?.name;
  const requestMethod = dataset?.endpoint_spec?.method;
  const path = dataset?.endpoint_spec?.route;
  const methodChipColor = getHttpMethodColor(requestMethod) as any;

  const handleConfigureClick = () => {
    openConfigModal(dataset?.id, dataset?.data_source_id, requestMethod);
  };

  const handleTestClick = () => {
    openTestModal(dataset?.id, dataset?.data_source_id, requestMethod);
  };

  return (
    <NodeBox data={dataset} className={styles.container}>
      <ResourceName {...props}>REQUEST</ResourceName>
      <div className={styles.requestContainer}>
        <NodeBox.Title>{requestName}</NodeBox.Title>
        <Stack direction="row">
          <Chip color={methodChipColor} label={requestMethod} variant="outlined" />
          <span className={styles.urlPath}>...{path}</span>
        </Stack>
      </div>
      <NodeBox.Footer className={styles.requestFooter}>
        <div className={styles.bottomActions}>
          <ChipWithCopy tooltipTitle="Copy Request ID" toCopy={dataset?.id}>
            ID {dataset?.id}
          </ChipWithCopy>
          {!isPreview && (
            <>
              <Button
                variant="outlined"
                color="primary"
                className={styles.configureButton}
                onClick={handleConfigureClick}
              >
                Configure
              </Button>
              <RequestActions onTest={handleTestClick} data={dataset} />
            </>
          )}
        </div>
      </NodeBox.Footer>
    </NodeBox>
  );
});
